import React from 'react';
import { Route } from 'react-router-dom';
import FadeIn from '../modules/animations/FadeIn';

export default function AppRoute({ provider: Provider, component: Component, path, isPrivate, ...props }) {
  return (
    <Route path={path}>
      {isPrivate ? (
        <div>Página privada</div>
      ) : (
        <FadeIn>
          <Component {...props} />
        </FadeIn>
      )}
    </Route>
  );
}
